import type { BulkOperationDetail, BulkValidatedRow } from './bulkOperations';

/** 적용되지 않은 검증 초안임을 확인한 경우에만 입력 수정을 다시 허용합니다. */
export class BulkPreApplyValidationError extends Error {
  constructor(public readonly rowErrors: Map<number, string[]>) {
    super('서버 검증에서 오류가 발견되었습니다. 아래 행별 오류를 확인하고 입력을 수정한 뒤 다시 검증해 주세요.');
    this.name = 'BulkPreApplyValidationError';
  }
}

export function assertBulkOperationValid(job: BulkOperationDetail, requestedRows: BulkValidatedRow[]) {
  if (job.validRows === job.totalRows) return;
  const invalidRows = job.rows.filter((row) => row.status === 'INVALID');
  if (job.status === 'VALIDATED' && invalidRows.length && !job.submittedAt && !job.completedAt && !job.succeededRows) {
    throw new BulkPreApplyValidationError(new Map(invalidRows.map((row) => [
      requestedRows[row.rowNumber - 1]?.rowNumber ?? row.rowNumber + 1,
      [row.errorMessage || '서버 검증에서 오류가 발견되었습니다. 입력값을 확인해 주세요.'],
    ])));
  }
  throw new Error('작업의 검증 상태를 확인하지 못했습니다. 같은 내용으로 다시 시도하거나 대량 작업 목록에서 처리 결과를 확인해 주세요.');
}
